import { decimalToLocalizedString, getFormattedValueAndUnitFromNumber } from 'ComponentLibrary/src/common/numbers'
import { isNil } from 'lodash'

class Percentage {
    readonly value: number
    constructor(value: number) {
        this.value = value
    }

    static PercentageOrUndefined(value: number | undefined | null): Percentage | undefined {
        return !isNil(value) ? new Percentage(value) : undefined
    }

    toPercentage() {
        return this.value * 100
    }

    format({
        numberOfDigits = 2,
        minimumNumberOfDigits = numberOfDigits,
        withSign,
        withUnit = true,
        withSpaceAfterSign = false,
        locale = 'de-DE',
    }: {
        numberOfDigits?: number
        minimumNumberOfDigits?: number
        withSign?: boolean
        withUnit?: boolean
        withSpaceAfterSign?: boolean
        locale?: string
    } = {}) {
        // - comes automatically with localized number formatting
        const sign = this.value > 0 ? '+' : ''
        const formattedValue = `${withSign && this.value !== 0 ? sign : ''}${decimalToLocalizedString(this.value * 100, false, numberOfDigits, minimumNumberOfDigits, locale)}${
            withUnit ? ' %' : ''
        }`
        return withSpaceAfterSign ? formattedValue.replace(/^([+-])/, '$1 ') : formattedValue
    }
}

export function getFormattedValueAndUnitFromPercentage(percentage?: number, numberOfDigits?: number, locale = 'de-DE') {
    if (percentage === undefined) {
        return { value: '-' }
    }
    const percentageClassObject = new Percentage(percentage)
    return getFormattedValueAndUnitFromNumber(percentageClassObject.toPercentage(), '%', numberOfDigits, locale)
}

const isPercentage = (percntage: Percentage | unknown): percntage is Percentage => {
    if (!(percntage instanceof Percentage)) {
        return false
    }
    return !isNaN(percntage.value)
}

export { Percentage, isPercentage }
